<template>
  <div class="panel">
    <div class="panel-heading">
      <h1 class="panel-title">动态</h1>
    </div>
    <div class="panel-body">
      <div class="mychilidTab-box clearfix">
        <ul class="nav nav-tabs child-tabs" id="mychlidTab">
          <li
            :class="{ active: header.id === 1 }"
            v-for="header in headers"
            :key="header.id"
            @click="switchTab(header)"
          >
            <a data-toggle="tab" :href="'#dynamic-' + header.class">{{
              header.title
            }}</a>
          </li>
        </ul>
      </div>
      <div class="tab-content">
        <div class="tab-pane fade in active" id="dynamic-all">
          <div class="dynamicwrap">
            <div
              class="dynamic"
              v-for="msg in messages"
              :key="msg.message_number"
            >
              <div class="dynamic-list">
                <div class="header">
                  <div
                    class="user-avator"
                    @click="goToUser(msg.message_creater_number)"
                  >
                    <img :src="msg.message_creater_avatar" />
                  </div>
                </div>
                <div class="comment">
                  <div class="name">
                    <h1>
                      <b @click="goToUser(msg.message_creater_number)">{{
                        msg.message_creater_name
                      }}</b>
                    </h1>
                  </div>

                  <MessageList
                    :msg="msg"
                    @goToUser="goToUser(msg.message_content_object.user[0].id)"
                    @goToGroup="goToGroup(msg.message_content_object.group.id)"
                    @goToFile="goToFile(msg.message_content_object)"
                    @goToShareMe="
                      goToShareMe(msg.message_content_object.share.id)
                    "
                    @goToMyShare="
                      goToMyShare(msg.message_content_object.share.id)
                    "
                    @goToApp="
                      goToApp(msg.message_content_object.application.id)
                    "
                    @goToOther="goToOther(msg.message_content_object.other.url)"
                  ></MessageList>
                </div>
                <div class="time">{{ msg.message_created_date }}</div>
                <!-- <div class="delete" @click="deleteMessage(msg)">删除</div> -->
                <div class="dropdown delete" ref="dropdown" v-if="right__message_delMessage">
                  <a
                    aria-expanded="true"
                    aria-haspopup="true"
                    class="dropdown-toggle"
                    data-toggle="dropdown"
                    ><i class="iconfont icon-more" title="更多"></i
                  ></a>
                  <ul
                    aria-labelledby="dropdownMenu2"
                    class="dropdown-menu dropdown-menu-right"
                  >
                    <li @click="deleteMessage(msg)">
                      <a>
                        <i class="iconfont icon-trash"></i>
                        删除
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="dynamic" v-show="!messages.length">
              <div class="dynamic-list">
                <div class="nomessage">暂无任何消息</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Page
        :page-index="currentPage"
        :total="count"
        :page-size="listQuery.limit"
        :showTotalPage="false"
        :showPageInput="false"
        :pagePosition="'right'"
        @change="pageChange"
      ></Page>
    </div>
  </div>
</template>

<script>
import { message, deleteMessage } from "@/api/user/message";
import { fileOrFolderInfo } from "@/api/drive/drive";
import { appList } from "@/api/common/index";
export default {
  name: "Message",
  components: {
    Page: () => import("@/views/Apps/Page"),
    MessageList: () => import("./MessageList"),
  },
  data() {
    return {
      currentPage: 1, //当前页码
      count: 0, //总记录数
      headers: [
        { id: 1, title: "全部", class: "all", category: null },
        { id: 2, title: "@我", class: "my", category: 2 },
        { id: 3, title: "群组", class: "group", category: 1 },
        // { id: 4, title: "Tex Online", class: "tex", category: 3 },
        { id: 5, title: "系统", class: "system", category: 0 },
      ],
      messages: [],
      deleteingMessages: [], // 正在删除的消息,可以防止多次删除同一个消息
      listQuery: {
        read_status: null,
        category: null,
        offset: 0,
        limit: 5,
      },
    };
  },
  created() {
    this.getMessage();
  },
  computed: {
    right__message_delMessage () {
      return this.$store.getters.right__message_delMessage
    },
  },
  methods: {
    // 删除消息
    deleteMessage(msg) {
      this.$confirm({
        type: "confirm",
        content: `确定删除吗？`,
        showCancleBtn: true,
        showYesBtn: true,
        custom: [],
      })
        .then(() => {
          if (this.deleteingMessages.indexOf(msg.message_number) > -1) {
            return false;
          }
          this.deleteingMessages.push(msg.message_number);
          deleteMessage({ id: msg.message_number })
            .then((res) => {
              if (res.status_code === 200) {
                let index = this.messages.findIndex(
                  (item) => item.message_number == msg.message_number
                );
                if (index > -1) {
                  this.messages.splice(index, 1);
                }
                this.getMessage();
                this.$message({
                  type: "success",
                  message: res.message,
                });
                let deleteIndex = this.deleteingMessages.findIndex(
                  (item) => item == msg.message_number
                );
                if (deleteIndex > -1) {
                  this.deleteingMessages.splice(deleteIndex, 1);
                }
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err,
              });
            });
        })
        .catch(() => {});
    },
    /**
     * 跳转到用户
     */
    goToUser(userNumber) {
      let routeUrl = this.$router.resolve({
        name: "user",
        params: { userNumber: userNumber },
      });
      window.open(routeUrl.href, "_blank");
    },

    /**
     * 跳转到群组
     */
    goToGroup(groupNumber) {
      let routeUrl = this.$router.resolve({
        name: "group",
        params: { groupNumber: groupNumber },
      });
      window.open(routeUrl.href, "_blank");
    },

    /**
     * 跳转到云盘/群盘文件
     */
    goToFile(msgObj) {
      fileOrFolderInfo({
        number: msgObj.file.id,
        type: "file",
        is_path: true,
        group_number: msgObj.group && msgObj.group.id ? msgObj.group.id : null,
      })
        .then((res) => {
          if (res.status_code === 200) {
            //根据msgObj.group是否存在判断跳转到云盘还是群盘
            if (msgObj.group && msgObj.group.id) {
              // 跳转到群盘(当前仅仅是跳转到群盘，没到具体文件所在目录)
              this.$router.push({
                name: "groupDisk",
                params: {
                  groupNumber: msgObj.group.id,
                },
                query: {
                  type: "file",
                  number: res.entity.parent_number,
                },
              });
            } else {
              // 跳转到云盘
              this.$router.push({
                name: "recdrive",
                query: {
                  tab: "file",
                  number: res.entity.parent_number,
                  disk_type: res.entity.disk_type,
                },
              });
            }
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },

    /**
     * 跳转到分享@我
     */
    goToShareMe(share_number) {
      let routeUrl = this.$router.resolve({
        name: "recdrive",
        query: {
          tab: "shareme",
          share_number: share_number,
        },
      });
      window.open(routeUrl.href, "_blank");
    },

    /**
     * 跳转到我的分享
     */
    goToMyShare(share_number) {
      let routeUrl = this.$router.resolve({
        name: "recdrive",
        query: {
          tab: "myshare",
          share_number: share_number,
        },
      });
      window.open(routeUrl.href, "_blank");
    },

    /**
     * 跳转到应用
     * 需要确定好返回的msgObj里面的参数
     */
    goToApp(app_number) {
      appList
        .then((res) => {
          if (res.status_code === 200) {
            let app = res.entity.find((item) => item.app_number === app_number);
            if (app) {
              this.$router.push({
                name: app.app_function_link,
              });
            }
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 跳转到给定的内部网址
    goToOther(url) {
      window.open(`${window.location.origin}${url}`, "_blank");
    },
    //从page组件传递过来的当前page
    pageChange(page) {
      this.currentPage = page;
      this.listQuery.offset = (this.currentPage - 1) * this.listQuery.limit;
      this.getMessage();
    },
    switchTab(header) {
      this.listQuery.offset = 0;
      this.currentPage = 1;
      this.listQuery.category = header.category;
      this.getMessage();
    },
    getMessage() {
      message(this.listQuery)
        .then((res) => {
          if (res.status_code === 200) {
            this.count = res.entity.total;
            this.messages = res.entity.datas;
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
  },
};
</script>

<style scoped>
</style>